import { render, staticRenderFns } from "./FormularioCtrlTipoServicoComponent.vue?vue&type=template&id=631e5820"
import script from "./FormularioCtrlTipoServicoComponent.vue?vue&type=script&lang=js"
export * from "./FormularioCtrlTipoServicoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports